import {Redirect, Route, RouteComponentProps, RouteProps} from "react-router-dom";
import React from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../store/store";

interface ProtectedRouteProps extends RouteProps {
    component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>
}

export default function ProtectedRoute({ component, ...args }: ProtectedRouteProps) {
    const authenticated = useSelector((state: RootState) => state.authentication.accessToken !== undefined)

    if (!authenticated) {
        return (
            <Redirect to="/auth/login" />
        )
    } else {
        return (
            <Route component={(component)} {...args} />
        )
    }
}